import { render, staticRenderFns } from "./Levels.vue?vue&type=template&id=d27af86c&scoped=true&"
import script from "./Levels.vue?vue&type=script&lang=js&"
export * from "./Levels.vue?vue&type=script&lang=js&"
import style0 from "./Levels.vue?vue&type=style&index=0&id=d27af86c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27af86c",
  null
  
)

export default component.exports